import AboutSection from "./aboutSection";
import IntroSection from "./IntroSection";
import EducationSection from "./educationSection";
import SkillSection from "./skillSection";
import PortfolioSection from "./portfolioSection";
import AwardSection from "./awardSection";
import CertSection from "./certSection";
import ActivitySection from "./activitySection";
import HobbySection from "./hobbySection";
import ContactSection from "./contactSection";
const HomeSection = () => (
  <main>
    <div className="site-container">
      <IntroSection />
      <AboutSection />
      <PortfolioSection />
      <SkillSection />
      <EducationSection />
      <AwardSection />
      <CertSection />
      <ActivitySection />
      <HobbySection />
      <ContactSection />
    </div>
  </main>
);
export default HomeSection;
